/**
 * Retrieve the string{PageName} from a given url in parameter
 * 
 * @description : Accepts theses urls patterns: `{*}/#pageName?{*}`
 * ex1: http://localhost:8080/#page1 => page1
 * ex2: http://localhost:8080/#page1?queryVersion=1 => page1
 * ex3: http://localhost:8080/ => an empty string
 *
 * @param {string} url - the url to retrieve pageName
 * @returns {string} - the hash of the url
 */
export function getHashFromUrl(url: string): string {
    const hashIndex = url.indexOf("#");
    if (hashIndex < 0) {
        return "";// No hash in the url
    }

    // Get the hash without the "#" string (+1)
    let hash = url.substring(hashIndex + 1);

    // Remove the query string from the url
    hash = hash.split("?")[0];
    return hash;
}